module.exports = __webpack_public_path__ + "img/loghi_0009_job_4_good.6632294c.png";